import styled, { keyframes } from "styled-components";

// Keyframe for fading effect
const fade = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
`;

const DotWrapper = styled.div`
  display: flex;
  gap: 3px;
  justify-content: center;
  margin-top: 10px;
`;

const Dot = styled.div`
  width: 6px;
  height: 6px;
  background: #97a3ae;
  border-radius: 6px;
  animation: ${fade} 1s infinite;
  animation-delay: ${(props) => props.delay}s;
`;

export const FourDotsLoader = () => {
  const delays = [0, 0.2, 0.4, 0.6];

  return (
    <DotWrapper>
      {delays.map((delay, index) => (
        <Dot key={index} delay={delay} />
      ))}
    </DotWrapper>
  );
};
